import { apiInstance, gql } from "@/services/httpAdapter";

// Types
import { IPaginatedResponse } from "@/Common/api/types/pagination";
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";

// Fragments
import { RepairOrderFragment } from "./fragments";

// Helpers
import { errorLogger } from "@/Common/helpers/logger";

export async function getRepairOrders(args: {
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	first: number;
	after: string;
}) {
	const { locationId, commissionCycleId, payPeriodId, first = 1000, after = "" } = args;

	const query = gql`
		query getRepairOrders($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $pagination: PaginationInput) {
			getRepairOrders(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				pagination: $pagination
			) {
				edges {
					cursor
					node {
						...RepairOrder
					}
				}
				pageInfo {
					endCursor
					hasNextPage
				}
			}
		}
		${RepairOrderFragment}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		pagination: {
			first,
			after: after ?? "",
		},
	};

	try {
		const response: GraphqlQueryResponse<"getRepairOrders", IPaginatedResponse<object>> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getRepairOrders;
	} catch (err) {
		errorLogger(err as Error, { function: "getRepairOrders", message: "Failed to get Repair Orders", variables });
		return null;
	}
}
